
    import React from 'react'
    import Base from '@ucheba/ui/components/Icon'
    import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js"
    import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js"

    const symbol = new SpriteSymbol({
  "id": "icon__tw_circle",
  "use": "icon__tw_circle-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon__tw_circle\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm6.464 9.535c.006.133.009.265.009.397 0 4.068-3.095 8.756-8.756 8.756A8.697 8.697 0 0 1 5 17.305c.241.029.486.042.735.042a6.157 6.157 0 0 0 3.821-1.318 3.08 3.08 0 0 1-2.875-2.137 3.072 3.072 0 0 0 1.39-.053 3.078 3.078 0 0 1-2.469-3.017v-.039c.415.231.889.369 1.394.385a3.077 3.077 0 0 1-.953-4.108 8.737 8.737 0 0 0 6.343 3.216 3.078 3.078 0 0 1 5.244-2.807 6.185 6.185 0 0 0 1.955-.747 3.09 3.09 0 0 1-1.354 1.703 6.15 6.15 0 0 0 1.768-.484 6.204 6.204 0 0 1-1.535 1.594z\" /></symbol>"
})
    sprite.add(symbol)

    export default React.memo(function IconTwCircleIcon(props) {
      const { className, ...restProps } = props
      return <Base.Icon className={className} id="icon__tw_circle" {...restProps} />
    })
  